import {UI} from "../../../stem-core/src/ui/UIBase";

import {Messages} from "../../Messages";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";
import {Image, Link} from "../../../stem-core/src/ui/UIPrimitives";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {merchantStyleRule} from "../Security";
import {isSmallScreen} from "../../UtilsLib";
import {iFrameState} from "../../services/IFrameState";
import {GATE_TYPE} from "../../../blink-sdk/Constants";
import {isString} from "../../../stem-core/src/base/Utils";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient";
import {PanelTypeToControllerClassMap} from "../flows/BasicFlowControllers";
import {MessageElement} from "../../widget/ui/MessageElement";


export function sanitizeUrlFromOptions(options, key) {
    if (!options[key]) {
        return options;
    }
    if (options[key]) {
        const invalidateUrl = () => {
            options[key] = "";
            options.value = options.label = options.alt = Messages.elementInvalidUrl(key);
        };
        try {
            const url = new URL(options[key]);
            if (["http:", "https:", "mailto:", "tel:"].indexOf(url.protocol) === -1) {
                invalidateUrl();
            }
        } catch (e) {
            invalidateUrl();
        }
    }
    return options;
}

export class MerchantLinkStyle extends StyleSheet {
    @styleRule
    link = {
        ...this.themeProps.AUTH_LINK_STYLE,
        fontSize: "inherit",
        whiteSpace: "nowrap",
    };
}

export function redirectOnClickLink(event, element) {
    if (event.shiftKey || event.ctrlKey || event.metaKey || element.options.newTab || element.options.href == null ||
        (element.options.target && element.options.target !== "_self")) {
        // Leave it to the browser
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    iFrameConnection.sendToSDK(IFrameMessages.REDIRECT_TO_URL, {url: element.options.href});
}

@registerStyle(MerchantLinkStyle)
export class PanelLink extends Link {
    static shouldSanitizeOptions = true;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.link);
    }

    setOptions(options) {
        return super.setOptions(this.constructor.shouldSanitizeOptions ? sanitizeUrlFromOptions(options, "href") : options);
    }

    onMount() {
        super.onMount();
        this.addClickListener(event => {
            dispatchAnalyticsEvent(AnalyticsEventType.ELEMENT_CLICK);
            redirectOnClickLink(event, this);
        });
    }
}

export class PanelImage extends Image {
    setOptions(options) {
        return super.setOptions(sanitizeUrlFromOptions(options, "src"));
    }

    onMount() {
        this.addLoadListener(() => Dispatcher.Global.dispatch("iframeSizeChange"));
    }
}

class PanelTextStyle extends StyleSheet {
    @merchantStyleRule
    text = {
        ...this.themeProps.PANEL_MESSAGE_STYLE,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        textAlign: () => (isSmallScreen() || iFrameState.gateType === GATE_TYPE.banner) ? "left" : "center",
        ...iFrameState.textStyle,
    };
}

@registerStyle(PanelTextStyle)
export class PanelText extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.text);
    }

    setOptions(options) {
        if (Array.isArray(options.children) && !options.children.length) {
            const controllerClass = PanelTypeToControllerClassMap[iFrameState.panelType];
            options.children = controllerClass ? (new controllerClass()).getHeaderDefaultText() : [];
        }
        if (Array.isArray(options.children) && options.children.length === 1) {
            options.children = options.children[0];
        }
        if (Array.isArray(options.children) && !options.children.length) {
            options.children = iFrameState.panelText || "";
        }
        if (isString(options.children) || options.children instanceof UI.TextElement) {
            options.children = options.children.toString().split("\n").map(line => <div style={{minHeight: "1em"}}>
                <MessageElement message={line} />
            </div>);
        }
        return super.setOptions(options);
    }
}
